import React, { useCallback } from "react";
import List from "@commonComponents/List";
import AuthorizationForm from "@EUForms/authorizationForm";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import { Grid } from "semantic-ui-react";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";
import MarkedDeleted from "../items/markedDeleted";
import { useDispatch } from "react-redux";
import { partiesInfo } from '../../util/partiesLabel'


const AuthorizationDetail = (props) => {
  const { 
    dataSource, 
    supplyChainOwnerList, 
    onSelect, 
    displayOwner = true, 
    isMerchandiseDisabled,
    isRFIDisabled,
    ...rest 
  } = props

  const dispatch = useDispatch()
  const { isRFI, isImportShipment } = useCurrentShipmentType()

  // updateItem
  const onMarkMerchandiseAuthDelete = (data, {id, tableName}) => {
    if (data.checked) {
      rest?.onChange(id, tableName,{id, markDelete: '1' })
      rest.onBlur(tableName, {id, markDelete: '1' })
    } else {
      rest?.onChange(id, tableName,{id, markDelete: '0' })
      rest.onBlur(tableName, {id, markDelete: '0' })
    }
  }
  
  const getData = (selectedOwner, callback) => (dispatch, getState) => {
    if (!selectedOwner) {
      callback('')
      return
    }
    const identification =
      getState().actorReducer[partiesInfo(isImportShipment)[selectedOwner?.toLowerCase()]?.tableName]?.[0]?.eoriNo || ''
    callback(identification)
  }
  
  const onOwnerChange = (params) => {
    return (e, { value, name }) => {
      const { dataSource, onSelect, tableName } = params
      const callback = (identification) => {
        onSelect(dataSource.id, tableName, {
          [name]: value,
          id: dataSource.id,
          role: dataSource.role,
          eoriNo:identification,
        })
      }
      dispatch(getData(value, callback))
    }
  }

  const renderAtLast = useCallback((params) => {
    if (!displayOwner) return null
    const { dataSource, onDropDownChange } = params
    return (
      <Grid.Column>
        <DropDown
          id={`owner${dataSource.id}`}
          clearable
          label="owner"
          labelClass="text-none"
          data={supplyChainOwnerList}
          name="owner"
          value={dataSource.owner}
          text={dataSource.owner}
          // onChange={onDropDownChange}
          onChange={onOwnerChange(params)}
        />
      </Grid.Column>
    )

  }, [supplyChainOwnerList, isMerchandiseDisabled])
  const renderItem = useCallback((item) => {
    const isAuthorizationDisabled = (isMerchandiseDisabled||(isRFI&&item?.markDelete=='1')||null)
    const onSelectHandler = (id, tableName, params, name) => {
      onSelect(id, tableName, params)
    }
    return <AuthorizationForm
      dataSource={item}
      key={item.id}
      onSelect={onSelectHandler}
      renderAtLast={renderAtLast}
      {...rest}
      isAuthorizationDisabled={isAuthorizationDisabled}
      markedDeleted={isRFI ? (params) => <MarkedDeleted
        label='_'
        className='marked-deleted marked-deleted-label-hidden'
        disabled={(isRFIDisabled||isMerchandiseDisabled)}
        checked={(isAuthorizationDisabled||false)}
        onChange={(e, data)=>onMarkMerchandiseAuthDelete(data,params)}
      /> : null}

    />
  }, [renderAtLast, rest, isMerchandiseDisabled])


  return <List className="responsiveGridCss" dataSource={dataSource} renderItem={renderItem} />

}

export default React.memo(AuthorizationDetail)
